export default "__VITE_ASSET__F1kw6GlH__"